import cn from 'classnames';
import React from 'react';
import type { FC } from 'react';

import type { DivProps } from '../../../../app.types';
import { Caption1 } from '../../Typography';
import { CircularProgressLarge } from '../CircularProgressLarge';

import s from './LoadingPage.module.scss';

interface LoadingPageTypes extends DivProps {
  title?: string;
}

export const LoadingPage: FC<LoadingPageTypes> = ({
  title,
  className,
  ...restProps
}) => {
  return (
    <div className={cn(s.wrapperLoading, className)} {...restProps}>
      <div className={cn(s.wrapperImage, s.loader)}>
        <CircularProgressLarge />
      </div>
      <Caption1 className={s.title}>
        {title ? title : 'Подождите, идет загрузка...'}
      </Caption1>
    </div>
  );
};
